import { useState, useEffect } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { useAuth } from "@/contexts/AuthContext";
import { logError } from "@/shared/services/ErrorReporting";
import { db } from "@/integrations/firebase/firestore";

export const useIsTenantAdmin = () => {
  const { authUser } = useAuth();
  const [isTenantAdmin, setIsTenantAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!authUser) {
      setIsTenantAdmin(false);
      setIsLoading(false);
      return;
    }

    const q = query(
      collection(db, "tenants"),
      where("admin_uids", "array-contains", authUser.uid),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        setIsTenantAdmin(!snapshot.empty);
        setIsLoading(false);
      },
      (err) => {
        logError(err);
        setIsTenantAdmin(false);
        setIsLoading(false);
      },
    );

    return () => unsubscribe();
  }, [authUser]);

  return { isTenantAdmin, isLoading };
};
